module.exports = __webpack_public_path__ + "img/home-o.cb5b8160.svg";